<div class="k-form-field-radiobutton-wrap radio-confirmation">
  @let control = $control();
  @let displayName = $displayName();
  <kendo-label class="k-display-block" [text]="displayName" />
  <kendo-stacklayout [gap]="20" [align]="{ horizontal: 'start' }">
    <kendo-stacklayout>
      <kendo-radiobutton #yes [checked]="control.value === true" [disabled]="control.disabled" (checkedChange)="onChange(true)" />
      <kendo-label class="k-radio-label" text="Yes" [for]="yes" />
    </kendo-stacklayout>
    <kendo-stacklayout>
      <kendo-radiobutton #no [checked]="control.value === false" [disabled]="control.disabled" (checkedChange)="onChange(false)" />
      <kendo-label class="k-radio-label" text="No" [for]="no" />
    </kendo-stacklayout>
  </kendo-stacklayout>
  @let hint = control && control.enabled ? $description() : '';
  <kendo-formhint>&nbsp;{{ $showHint() ? hint : '' }}</kendo-formhint>
  <unity-error-wrapper ngProjectAs="kendo-formerror" [control]="control" [displayName]="displayName" />
</div>
